// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gs-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1100;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: calc(8vh / var(--app-zoom, 1));
}

.gs-modal {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    width: calc(86vw / var(--app-zoom, 1));
    max-width: 1000px;
    height: calc(78vh / var(--app-zoom, 1));
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.gs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background: #f8f9fa;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
}

.gs-header h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
}

.gs-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #6b7280;
    padding: 4px;
    display: flex;
    align-items: center;
    border-radius: 4px;
}

.gs-close:hover {
    background: #e5e7eb;
    color: #111827;
}

.gs-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-bottom: 1px solid #e5e7eb;
    background: #fafafa;
    flex-shrink: 0;
}

.gs-input {
    flex: 1 1;
    padding: 6px 10px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    font-size: 13px;
    color: #1f2937;
    background: #fff;
}

.gs-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.gs-opt {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #4b5563;
    cursor: pointer;
    white-space: nowrap;
}

.gs-opt input {
    cursor: pointer;
}

.gs-stats {
    font-size: 12px;
    color: #6b7280;
    white-space: nowrap;
}

.gs-results {
    flex: 1 1;
    overflow-y: auto;
    padding: 8px 10px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.gs-empty {
    padding: 40px 16px;
    text-align: center;
    color: #9ca3af;
    font-family: system-ui, sans-serif;
    font-size: 13px;
}

.gs-group {
    margin-bottom: 12px;
}

.gs-group-head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 4px;
    font-family: system-ui, sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #1f2937;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 4px;
}

.gs-group-count {
    margin-left: auto;
    color: #9ca3af;
    font-weight: 500;
    font-size: 11px;
}

.gs-file {
    margin-left: 12px;
    margin-bottom: 6px;
}

.gs-file-head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 4px;
    font-family: system-ui, sans-serif;
    font-size: 12px;
    color: #374151;
    font-weight: 500;
}

.gs-file-name {
    color: #1e40af;
}

.gs-file-count {
    margin-left: auto;
    color: #9ca3af;
    font-size: 11px;
}

.gs-match {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 6px 3px 20px;
    cursor: pointer;
    border-radius: 3px;
    font-size: 12px;
    color: #374151;
    line-height: 1.45;
    white-space: nowrap;
    overflow: hidden;
}

.gs-match:hover {
    background: #eff6ff;
}

.gs-line-no {
    color: #9ca3af;
    font-variant-numeric: tabular-nums;
    min-width: 44px;
    display: inline-block;
    flex-shrink: 0;
}

.gs-snippet {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
}

.gs-snippet-prefix,
.gs-snippet-suffix {
    color: #6b7280;
}

.gs-snippet-match {
    background: #fef08a;
    color: #713f12;
    padding: 0 2px;
    border-radius: 2px;
}

/* ===== 다크모드 ===== */
[data-theme="dark"] .gs-modal {
    background: var(--color-bg-tertiary);
    color: var(--color-text);
}

[data-theme="dark"] .gs-header {
    background: var(--color-bg-secondary);
    border-bottom-color: var(--color-border);
}

[data-theme="dark"] .gs-header h3 {
    color: var(--color-text);
}

[data-theme="dark"] .gs-close {
    color: var(--color-text-muted);
}

[data-theme="dark"] .gs-close:hover {
    background: var(--color-hover);
    color: var(--color-text);
}

[data-theme="dark"] .gs-toolbar {
    background: var(--color-bg-secondary);
    border-bottom-color: var(--color-border);
}

[data-theme="dark"] .gs-input {
    background: var(--color-input-bg);
    border-color: var(--color-input-border);
    color: var(--color-text);
}

[data-theme="dark"] .gs-input:focus {
    border-color: var(--color-accent-fg);
}

[data-theme="dark"] .gs-opt {
    color: var(--color-text-secondary);
}

[data-theme="dark"] .gs-stats {
    color: var(--color-text-muted);
}

[data-theme="dark"] .gs-group-head {
    color: var(--color-text);
    border-bottom-color: var(--color-border);
}

[data-theme="dark"] .gs-group-count,
[data-theme="dark"] .gs-file-count {
    color: var(--color-text-muted);
}

[data-theme="dark"] .gs-file-head {
    color: var(--color-text);
}

[data-theme="dark"] .gs-file-name {
    color: #93c5fd;
}

[data-theme="dark"] .gs-match {
    color: var(--color-text);
}

[data-theme="dark"] .gs-match:hover {
    background: var(--color-hover);
}

[data-theme="dark"] .gs-line-no,
[data-theme="dark"] .gs-snippet-prefix,
[data-theme="dark"] .gs-snippet-suffix {
    color: var(--color-text-muted);
}

[data-theme="dark"] .gs-snippet-match {
    background: rgba(250, 204, 21, 0.3);
    color: #fef08a;
}

[data-theme="dark"] .gs-empty {
    color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/GlobalSearchModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,sCAAsC;IACtC,iBAAiB;IACjB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;AACX;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".gs-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.45);\r\n    z-index: 1100;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    padding-top: calc(8vh / var(--app-zoom, 1));\r\n}\r\n\r\n.gs-modal {\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 10px 40px rgba(0,0,0,0.25);\r\n    width: calc(86vw / var(--app-zoom, 1));\r\n    max-width: 1000px;\r\n    height: calc(78vh / var(--app-zoom, 1));\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.gs-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 14px;\r\n    background: #f8f9fa;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.gs-header h3 {\r\n    margin: 0;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n}\r\n\r\n.gs-close {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #6b7280;\r\n    padding: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: 4px;\r\n}\r\n\r\n.gs-close:hover {\r\n    background: #e5e7eb;\r\n    color: #111827;\r\n}\r\n\r\n.gs-toolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 10px 14px;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    background: #fafafa;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.gs-input {\r\n    flex: 1;\r\n    padding: 6px 10px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 5px;\r\n    font-size: 13px;\r\n    color: #1f2937;\r\n    background: #fff;\r\n}\r\n\r\n.gs-input:focus {\r\n    outline: none;\r\n    border-color: #3b82f6;\r\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\r\n}\r\n\r\n.gs-opt {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    font-size: 12px;\r\n    color: #4b5563;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n}\r\n\r\n.gs-opt input {\r\n    cursor: pointer;\r\n}\r\n\r\n.gs-stats {\r\n    font-size: 12px;\r\n    color: #6b7280;\r\n    white-space: nowrap;\r\n}\r\n\r\n.gs-results {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 8px 10px;\r\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\r\n}\r\n\r\n.gs-empty {\r\n    padding: 40px 16px;\r\n    text-align: center;\r\n    color: #9ca3af;\r\n    font-family: system-ui, sans-serif;\r\n    font-size: 13px;\r\n}\r\n\r\n.gs-group {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.gs-group-head {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 6px 4px;\r\n    font-family: system-ui, sans-serif;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.02em;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.gs-group-count {\r\n    margin-left: auto;\r\n    color: #9ca3af;\r\n    font-weight: 500;\r\n    font-size: 11px;\r\n}\r\n\r\n.gs-file {\r\n    margin-left: 12px;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.gs-file-head {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 3px 4px;\r\n    font-family: system-ui, sans-serif;\r\n    font-size: 12px;\r\n    color: #374151;\r\n    font-weight: 500;\r\n}\r\n\r\n.gs-file-name {\r\n    color: #1e40af;\r\n}\r\n\r\n.gs-file-count {\r\n    margin-left: auto;\r\n    color: #9ca3af;\r\n    font-size: 11px;\r\n}\r\n\r\n.gs-match {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 3px 6px 3px 20px;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n    font-size: 12px;\r\n    color: #374151;\r\n    line-height: 1.45;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n.gs-match:hover {\r\n    background: #eff6ff;\r\n}\r\n\r\n.gs-line-no {\r\n    color: #9ca3af;\r\n    font-variant-numeric: tabular-nums;\r\n    min-width: 44px;\r\n    display: inline-block;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.gs-snippet {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    flex: 1;\r\n}\r\n\r\n.gs-snippet-prefix,\r\n.gs-snippet-suffix {\r\n    color: #6b7280;\r\n}\r\n\r\n.gs-snippet-match {\r\n    background: #fef08a;\r\n    color: #713f12;\r\n    padding: 0 2px;\r\n    border-radius: 2px;\r\n}\r\n\r\n/* ===== 다크모드 ===== */\r\n[data-theme=\"dark\"] .gs-modal {\r\n    background: var(--color-bg-tertiary);\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-header {\r\n    background: var(--color-bg-secondary);\r\n    border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-header h3 {\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-close {\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-close:hover {\r\n    background: var(--color-hover);\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-toolbar {\r\n    background: var(--color-bg-secondary);\r\n    border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-input {\r\n    background: var(--color-input-bg);\r\n    border-color: var(--color-input-border);\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-input:focus {\r\n    border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-opt {\r\n    color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-stats {\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-group-head {\r\n    color: var(--color-text);\r\n    border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-group-count,\r\n[data-theme=\"dark\"] .gs-file-count {\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-file-head {\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-file-name {\r\n    color: #93c5fd;\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-match {\r\n    color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-match:hover {\r\n    background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-line-no,\r\n[data-theme=\"dark\"] .gs-snippet-prefix,\r\n[data-theme=\"dark\"] .gs-snippet-suffix {\r\n    color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-snippet-match {\r\n    background: rgba(250, 204, 21, 0.3);\r\n    color: #fef08a;\r\n}\r\n\r\n[data-theme=\"dark\"] .gs-empty {\r\n    color: var(--color-text-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
